import { convertToFullMonth } from '@/utils/dateTimeHelpers';

import style from '../assets/newReleaseStyle';
import sanitize from '../utils/sanitize';
import genContactCardTemplate from './contactCard';
import { generateFooterTemplate, generateHeaderTemplate } from './headerFooter';

const host = process.env.API_ROOT;

const HTML_TEMPLATES = {
  bendData: ({
    data: { Title, PublishDateTime, Body, NewsReleaseFooter, Attachments, StandardNr },
    type,
    contacts,
    contactPics,
  }) => {
    return `
      <div>
        <header class="apcia-daneel-header">
          <div class="apcia-xcdwfm-container-lg-Container">
            <div class="apcia-1wc3eld-title-abovetitle-Hero">
              <div class="sanitized ">
                <h5>${
                  StandardNr === 'Y' ? 'FOR RELEASE ON RECEIPT' : 'SETTING THE RECORD STRAIGHT'
                }</h5>
                <div class="lineBreak"></div>
                ${convertToFullMonth(PublishDateTime)}
              </div>
            </div>
            <h1 class="apcia-pqxe18-1-normal-jumbo-Heading-title-title-Hero">${Title}</h1>
          </div>
        </header>
        <div class="apcia-xcdwfm-container-lg-Container">
          <main class="apcia-yst2bu-link-content-2-bold-2-bold-link-body-CMSPage">
            <div class="sanitized ">
              ${sanitize((Body || '').replace(/<br \/><br \/>/g, "<div class='lineBreak'></div>"))}
            </div>
            <section class="apcia-1wwsf3b-boilerplate">
              ${NewsReleaseFooter}
            </section>
            <div class="apcia-wsc2pe-center">###</div>
            ${
              type !== 'publication' && (Attachments || []).length
                ? `
              <h3 id="relatedinformation" class="apcia-dfi6ev-3-bolder-primaryGray-Heading-css-Subsection-CMSPage">
                Related Information
              </h3>
              <div class="apcia-3j1ie7-Subsection">
                <div class="ant-table-wrapper apcia-1dqms1f-table-CMSPage">
                  <div class="ant-spin-nested-loading">
                    <div class="ant-spin-container">
                      <div
                        class="ant-table ant-table-default ant-table-without-column-header ant-table-scroll-position-left">
                        <div class="ant-table-content">
                          <div class="ant-table-body">
                            <table class="">
                              <colgroup>
                                <col>
                              </colgroup>
                              <tbody class="ant-table-tbody">
                                ${Attachments.map(
                                  attach => `
                                  <tr class="ant-table-row ant-table-row-level-0" data-row-key="${
                                    attach.AttachmentId
                                  }">
                                    <td class="">
                                      <a
                                        href="${attach.href}"
                                        title="${attach.FileName}" download="${
                                    attach.FileName
                                  }" class="apcia-1d6vemk-link">
                                        <i
                                          aria-label="icon: file-unknown"
                                          class="anticon anticon-file-unknown apcia-1gtgrwu-icon"><svg viewBox="64 64 896 896"
                                            focusable="false" class="" data-icon="file-unknown" width="1em" height="1em"
                                            fill="currentColor" aria-hidden="true">
                                            <path
                                              d="M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM402 549c0 5.4 4.4 9.5 9.8 9.5h32.4c5.4 0 9.8-4.2 9.8-9.4 0-28.2 25.8-51.6 58-51.6s58 23.4 58 51.5c0 25.3-21 47.2-49.3 50.9-19.3 2.8-34.5 20.3-34.7 40.1v32c0 5.5 4.5 10 10 10h32c5.5 0 10-4.5 10-10v-12.2c0-6 4-11.5 9.7-13.3 44.6-14.4 75-54 74.3-98.9-.8-55.5-49.2-100.8-108.5-101.6-61.4-.7-111.5 45.6-111.5 103zm110 227a32 32 0 1 0 0-64 32 32 0 0 0 0 64z">
                                            </path>
                                          </svg>
                                        </i>
                                        <span>${attach.FileName}</span>
                                      </a>
                                    </td>
                                  </tr>
                                `
                                ).join('')}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            `
                : ''
            }
            <div class="apcia-chg8mh-footer">
              <a href="${host}/legal/copyright" class="apcia-loigxv-link-css-CustomLink">
                Copyright Notice
              </a>
              <span class="apcia-1vsublt-CMSPage">&nbsp;|&nbsp;</span>
              <a href="${host}/legal/disclaimer" class="apcia-loigxv-link-css-CustomLink">
                Legal Disclaimer
              </a>
            </div>
            <div class="apcia-kna8zu-body">
              <section class="apcia-vsbbwo-section">
                <div class="apcia-ce1fcy-staffContacts">
                  <div class="apcia-4vk7mv-container">
                    <div class="ant-card apcia-vkrnqj-cardSmall">
                      <div class="ant-card-head">
                        <div class="ant-card-head-wrapper">
                          <div class="ant-card-head-title">
                            <h3 class="apcia-1joqbhy-title">Contact${
                              contacts.length > 1 ? 's' : ''
                            }</h3>
                          </div>
                        </div>
                      </div>
                      <div class="ant-card-body">
                        <div class="apcia-xfxbk7-inner-ContactCard">
                          ${genContactCardTemplate(contacts, contactPics)}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </main>
        </div>
      </div>
    `;
  },
};

export function generateHTMLString(data) {
  return `
    ${generateHeaderTemplate(style)}
    ${HTML_TEMPLATES.bendData(data)}
    ${generateFooterTemplate()}
  `;
}
